module.exports = __webpack_public_path__ + "static/media/Meghan Flanagan Headshot.343d5106.jpeg";